import React, { useRef } from 'react'
import { Routes, Route, useNavigate } from 'react-router-dom'
import ProfiloUtente from './ProfiloUtente'
import NuovaRichiestaFormV2 from './NuovaRichiestaFormV2'
import Dashboard from './Dashboard'
import NotFound from './NotFound'
import ModificaPassword from './ModificaPassword'
import SessioneScaduta from './SessioneScaduta'
import { AuthContext } from '../App'
import OnlyWithFunction from '../OnlyWithFunctions'
import { useContext, useEffect } from 'react'
import StatistichePanel from './StatistichePanel'
import Accounting from './Accounting'
import SintesiAccouting from "./SintesiAccounting";
import { validateToken } from '../services/validateToken'
import TransitionComponentSnackbar from '../UI/CustomSnackbar';
import Monitoring from './Monitoring'
import DettaglioMonitoraggio from './DettaglioMonitoraggio'
import DettaglioSoggettoTerzo from './DettaglioSoggettoTerzo'
import StatisticheMonitoraggio from './StatisticheMonitoraggio'
import SoggettiTerziMonitoraggio from './SoggettiTerziMonitoraggio'
import Dettaglio from './Dettaglio'
import DettaglioV2 from './DettaglioV2'

const HomePage = () => {
  const navigate = useNavigate()
  const { state: AuthState, dispatch } = useContext(AuthContext)
  const tokenValidationTimeoutRef = useRef(null);

  useEffect(() => {
    if (localStorage.getItem('token') === null) {
      dispatch({ type: 'LOGOUT' }); // Usa il dispatch per gestire il logout
      navigate("/login");
    }else{
      validateToken().catch(() => {
        dispatch({ type: 'LOGOUT' });
        navigate("/login");
      });
    }
  }, [navigate, dispatch]);



  const checkToken = async () => {
    try {
      await validateToken();
    } catch (error) {
      console.error("Errore imprevisto nella convalida del token:", error);

    }
  };


  useEffect(() => {
    tokenValidationTimeoutRef.current = setTimeout(checkToken, 3600000);

    return () => {
      clearTimeout(tokenValidationTimeoutRef.current);
    };
  }, [dispatch]);


  useEffect(() => {
    if (localStorage.getItem('token') === null) {
      AuthState.isAuthenticated = false
      navigate("/login")
    }
  }, [localStorage])

  return (
    <div style={{ position: "relative" }}>
      <TransitionComponentSnackbar />
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/dettaglio/:codiceFiscale" element={<DettaglioV2 />} />

{/*
        <Route path="dettaglio" element={<Dettaglio />} />
*/}
        <Route path="dettaglioMonitoraggio" element={<DettaglioMonitoraggio />} />

        {/*<Route
          path="nuova-richiesta"
          element={
            <OnlyWithFunction acceptedFunction="NUOVA_ADV">
              <NuovaRichiestaFormV2 />
            </OnlyWithFunction>
          }
        />*/}
        <Route
          path="nuova-richiesta"
          element={
            <OnlyWithFunction acceptedFunction="NUOVA_ADV">
              <NuovaRichiestaFormV2 />
            </OnlyWithFunction>
          }
        />
        <Route
          path="/statistiche"
          element={
            <StatistichePanel />
          }
        />
        <Route
          path="/accounting"
          element={
            <Accounting />
          }
        />
        <Route
          path="/sintesi-accounting"
          element={
            <SintesiAccouting onlySintesi={true} />
          }
        />
        <Route
          path="/monitoring"
          element={
            <Monitoring />
          }
        />
        <Route
          path="/accounting-monitoraggio"
          element={
            <StatisticheMonitoraggio />
          }
        />
        <Route
           path="/soggetti-terzi-monitoraggio"
           element={
             <SoggettiTerziMonitoraggio />
           }
        />
        <Route path="dettaglioSoggettoTerzo" element={<DettaglioSoggettoTerzo />} />
        <Route path="/error" element={<NotFound />} />
        <Route path="/profilo-utente" element={<ProfiloUtente />} />
        <Route path="/modifica-password" element={<ModificaPassword />} />
        <Route path="/sessione-scaduta" element={<SessioneScaduta />} />
      </Routes>
    </div>
  )
}

export default HomePage
